import React, { Component } from "react";
import { Link, Redirect } from "react-router-dom";
import Loader from "react-loader-spinner";
import Header from "../components/header/header";
import Footer from "../components/statics/footer";
import {
  Row,
  Col,
  Container,
  Button,
  Form,
  FormGroup,
  Label,
  Input,
  FormFeedback,
  FormText,
  Alert,
  NavLink
} from "reactstrap";
import { connect } from "react-redux";
import * as UserProvider from "../providers/userProvider";
import * as action from "../actions/index";

var alert_types = {
  danger: "danger"
};
const validEmail = value =>
  /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(value) ? true : false;
const required = value => (value ? true : false);
class SignUpScreen extends Component {
  constructor(props) {
    super(props);
    this.state = {
      step: 0,
      payload: {
        firstName: "",
        lastName: "",
        email: "",
        password: "",
        taxPayer: "",
        isProfessional: false
      },
      address: {
        city: "",
        district: "",
        street: "",
        postalCode: "",
        number: "",
        reference: ""
      },
      professionalPayload: {
        bankAccount: "0",
        bankAgency: "0",
        accountTaxPayer: "0",
        holderName: "0",
        chatPrice: "0",
        videoPrice: "0",
        categoryId: ""
      },
      /* first_name: "",
      last_name: "",
      email: "",
      pass: "", */
      confirm_pass: "",
      showAlert: false,
      emailValid: true,
      passValid: true,
      passConfirmValid: true,
      emailValidationMsg: "",
      passValidationMsg: "",
      passConfirmValidationMsg: "",
      typeChoosed: false,
      type: "",
      firstnameValid: true,
      lastnameValid: true,
      userIdFile: "",
      professionalFile: "",
      termsAccepted: false
    };
    this.handleSubmit = this.handleSubmit.bind(this);
    this.onBlurEmail = this.onBlurEmail.bind(this);
    this.onBlurPass = this.onBlurPass.bind(this);
    this.onBlurPassConfirm = this.onBlurPassConfirm.bind(this);
    this.getValue = this.getValue.bind(this);
    this.chooseType = this.chooseType.bind(this);
    this.onDismiss = this.onDismiss.bind(this);
    this.onBlurName = this.onBlurName.bind(this);
    this.onBlurLastName = this.onBlurLastName.bind(this);
  }
  onBlurPass() {
    required(this.state.payload.password)
      ? this.setState({ passValid: true, passValidationMsg: "" })
      : this.setState({
          passValid: false,
          passValidationMsg: "Campo obrigatório"
        });
  }
  onBlurPassConfirm() {
    if (required(this.state.confirm_pass)) {
      if (
        required(this.state.payload.password) &&
        this.state.payload.password == this.state.confirm_pass
      ) {
        this.setState({ passConfirmValid: true, passConfirmValidationMsg: "" });
      } else {
        this.setState({
          passConfirmValid: false,
          passConfirmValidationMsg: "As senhas não conferem!"
        });
      }
    } else {
      this.setState({
        passConfirmValid: false,
        passConfirmValidationMsg: "Campo obrigatório"
      });
    }
  }
  onBlurEmail() {
    if (this.state.email != "") {
      validEmail(this.state.payload.email)
        ? this.setState({ emailValid: true, emailValidationMsg: "" })
        : this.setState({
            emailValid: false,
            emailValidationMsg: "Email não é válido"
          });
    } else {
      this.setState({
        emailValid: false,
        emailValidationMsg: "Campo obrigatório"
      });
    }
  }
  onBlurName() {
    if (this.state.payload.firstName != "") {
      this.setState({ firstnameValid: true });
    } else {
      this.setState({ firstnameValid: false });
    }
  }
  onBlurLastName() {
    if (this.state.payload.lastName != "") {
      this.setState({ lastnameValid: true });
    } else {
      this.setState({ lastnameValid: false });
    }
  }
  getValue = (key, event) => {
    this.setState({ [`${key}`]: event.target.value });
  };
  onChangeForm = (updateObj, formKey) => {
    this.setState(prevState => ({
      ...prevState,
      [formKey]: {
        ...prevState[formKey],
        ...updateObj
      }
    }));
  };
  validateFields() {
    if (
      this.state.firstnameValid &&
      this.state.lastnameValid &&
      this.state.emailValid &&
      this.state.passValid &&
      this.state.passConfirmValid &&
      this.state.payload.taxPayer
    ) {
      return true;
    } else {
      return false;
    }
  }
  validateAddress = () => {};
  validateProfessionalInfo = () => {};
  handleSubmit = async () => {
    await this.props.doSignUp({
      ...this.state.payload,
      address: this.state.address,
      ...this.state.professionalPayload
    });
    if (this.props.createAccountError) return;
    //redirect
  };
  renderLoading() {
    return (
      <div
        style={{
          right: 0,
          display: "flex",
          position: "absolute",
          backgroundColor: "rgba(0,0,0,0.1)",
          width: "100%",
          height: "100%",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          left: 0,
          top: 0,
          zIndex: 99
        }}
      >
        <Loader
          type="Oval"
          color="#00BFFF"
          height="80"
          width="80"
          margin-top="20"
        />
      </div>
    );
  }
  onDismiss() {
    this.props.doSetCreateAccountError("");
  }
  renderAlert() {
    return (
      <Alert color={alert_types.danger} toggle={this.onDismiss}>
        {this.props.createAccountError}
      </Alert>
    );
  }
  chooseType(type) {
    const isProfessional = type === "consultant";
    this.onChangeForm({ isProfessional }, "payload");
    this.setState({ typeChoosed: true, type: type });
    this.nextStep();
  }

  isInvalid = object => {
    return Object.entries(object).some(field => {
      const [key, value] = field;
      //console.log(key, value);
      if (key === "isProfessional") return false;
      if (key === "reference") return false;
      return !value;
    });
  };

  previousStep = (e = null) => {
    if (e) e.preventDefault();
    this.setState({ step: this.state.step - 1 });
  };

  nextStep = (e = null) => {
    if (e) e.preventDefault();
    const { step, type } = this.state;
    if (step === 3) {
      this.handleSubmit();
      return;
    }
    if (step === 2 && type === "customer") {
      this.handleSubmit();
      return;
    }
    this.setState({ step: step + 1 });
  };

  renderInitialPage = () => {
    return (
      <Col className="my-5 p-0 justify-content-center">
        <div className="mb-3">
          <h4 className="text-center">Escolha uma opção de cadastro</h4>
        </div>
        <Row className="justify-content-center mb-5 hide-if-mobile-flex">
          <Button
            className="btn btn-lg btn-primary"
            onClick={() => this.chooseType("customer")}
          >
            {" "}
            Quero me consultar
          </Button>
          <Button
            className="btn btn-lg btn-dark px-5 ml-5"
            onClick={() => this.chooseType("consultant")}
          >
            {" "}
            Sou um médico/especialista
          </Button>
        </Row>
        <Col
          className="justify-content-center mx-auto mb-5 p-0 show-if-mobile"
          style={{ width: "100%" }}
        >
          <Button
            className="btn btn-lg btn-primary"
            style={{ fontSize: 18, width: "100%" }}
            onClick={() => this.chooseType("customer")}
          >
            {" "}
            Quero solicitar uma consultoria
          </Button>
          <Button
            className="btn btn-lg btn-dark mt-3"
            style={{ fontSize: 18, width: "100%" }}
            onClick={() => this.chooseType("consultant")}
          >
            {" "}
            Quero ser um consultor
          </Button>
        </Col>
        <Col className="justify-content-center align-items-center mt-3">
          <h5 style={{ textAlign: "center" }}>
            Você já é cadastrado?
            <br />
            <Link to="/login" style={{ color: "#267e96", fontSize: 22 }}>
              Entrar
            </Link>
          </h5>
        </Col>
      </Col>
    );
  };

  renderAccountForm = () => {
    return (
      <React.Fragment>
        <div>
          <div className="padding text-center">
            <h3>Cadastro</h3>
          </div>
          <Row form>
            <Col md={6}>
              <FormGroup>
                <Label>Nome</Label>
                <Input
                  value={this.state.payload.firstName}
                  onChange={e =>
                    this.onChangeForm({ firstName: e.target.value }, "payload")
                  }
                  invalid={!this.state.firstnameValid}
                  onBlur={this.onBlurName}
                />
                {!this.state.firstnameValid ? (
                  <FormFeedback>Campo obrigatório.</FormFeedback>
                ) : null}
              </FormGroup>
            </Col>
            <Col md={6}>
              <FormGroup>
                <Label>Sobrenome</Label>
                <Input
                  value={this.state.payload.lastName}
                  onChange={e =>
                    this.onChangeForm({ lastName: e.target.value }, "payload")
                  }
                  invalid={!this.state.lastnameValid}
                  onBlur={this.onBlurLastName}
                />
                {!this.state.lastnameValid ? (
                  <FormFeedback>Campo obrigatório.</FormFeedback>
                ) : null}
              </FormGroup>
            </Col>
          </Row>
          <FormGroup>
            <Label>Email</Label>
            <Input
              value={this.state.payload.email}
              onChange={e =>
                this.onChangeForm({ email: e.target.value }, "payload")
              }
              invalid={!this.state.emailValid}
              onBlur={this.onBlurEmail}
            />
            {!this.state.emailValid ? (
              <FormFeedback>{this.state.emailValidationMsg}</FormFeedback>
            ) : null}
          </FormGroup>
          <FormGroup>
            <Label>CPF</Label>
            <Input
              value={this.state.payload.taxPayer}
              onChange={e =>
                this.onChangeForm({ taxPayer: e.target.value }, "payload")
              }
            />
          </FormGroup>
          <Row form>
            <Col md={6}>
              <FormGroup>
                <Label>Senha</Label>
                <Input
                  value={this.state.payload.password}
                  onChange={e =>
                    this.onChangeForm({ password: e.target.value }, "payload")
                  }
                  invalid={!this.state.passValid}
                  type="password"
                  name="password"
                  onBlur={this.onBlurPass}
                />
                {!this.state.passValid ? (
                  <FormFeedback>{this.state.passValidationMsg}</FormFeedback>
                ) : null}
                <FormText>Deve ter no mínino 6 dígitos</FormText>
              </FormGroup>
            </Col>
            <Col md={6}>
              <FormGroup>
                <Label>Confirmação de senha</Label>
                <Input
                  value={this.state.confirm_pass}
                  onChange={e =>
                    this.setState({ confirm_pass: e.target.value })
                  }
                  invalid={!this.state.passConfirmValid}
                  type="password"
                  name="password"
                  onBlur={this.onBlurPassConfirm}
                />
                {!this.state.passConfirmValid ? (
                  <FormFeedback>
                    {this.state.passConfirmValidationMsg}
                  </FormFeedback>
                ) : null}
              </FormGroup>
            </Col>
          </Row>
          <FormGroup check>
            <Label check>
              <Input
                type="checkbox"
                checked={this.state.termsAccepted}
                onChange={() =>
                  this.setState({
                    termsAccepted: !this.state.termsAccepted
                  })
                }
              />
              Aceitar <a href="/#/signup">termos de uso</a>
            </Label>
          </FormGroup>
        </div>
        <Button
          disabled={
            !this.state.termsAccepted || this.isInvalid(this.state.payload)
          }
          className="btn btn-dark btn-form mb-1 mt-3 d-block mx-auto"
          type="submit"
          value="Submit"
        >
          Continuar
        </Button>
      </React.Fragment>
    );
  };

  /* city: "",
        district: "",
        street: "",
        postalCode: "",
        number: "",
        reference: "" */

  renderAddressForm = () => {
    return (
      <React.Fragment>
        <div>
          <div className="padding text-center relative">
            <button onClick={this.previousStep} className="back-btn">
              Voltar
            </button>
            <h3>Endereço</h3>
          </div>
          <Row form>
            <Col md={6}>
              <FormGroup>
                <Label>Cidade</Label>
                <Input
                  value={this.state.address.city}
                  onChange={e =>
                    this.onChangeForm({ city: e.target.value }, "address")
                  }
                />
              </FormGroup>
            </Col>
            <Col md={6}>
              <FormGroup>
                <Label>Bairro</Label>
                <Input
                  value={this.state.address.district}
                  onChange={e =>
                    this.onChangeForm({ district: e.target.value }, "address")
                  }
                />
              </FormGroup>
            </Col>
          </Row>
          <FormGroup>
            <Label>Rua</Label>
            <Input
              value={this.state.address.street}
              onChange={e =>
                this.onChangeForm({ street: e.target.value }, "address")
              }
            />
          </FormGroup>
          <Row form>
            <Col md={6}>
              <FormGroup>
                <Label>CEP</Label>
                <Input
                  value={this.state.address.postalCode}
                  onChange={e =>
                    this.onChangeForm({ postalCode: e.target.value }, "address")
                  }
                />
              </FormGroup>
            </Col>
            <Col md={6}>
              <FormGroup>
                <Label>Número</Label>
                <Input
                  value={this.state.address.number}
                  onChange={e =>
                    this.onChangeForm({ number: e.target.value }, "address")
                  }
                />
              </FormGroup>
            </Col>
          </Row>
          <FormGroup>
            <Label>Referência</Label>
            <Input
              value={this.state.address.reference}
              onChange={e =>
                this.onChangeForm({ reference: e.target.value }, "address")
              }
            />
          </FormGroup>
        </div>
        <Button
          disabled={this.isInvalid(this.state.address)}
          className="btn btn-dark btn-form mb-1 mt-3 d-block mx-auto"
          type="submit"
          value="Submit"
        >
          {this.state.type === "customer" ? "Cadastrar" : "Continuar"}
        </Button>
      </React.Fragment>
    );
  };

  /* bankAccount: "",
        bankAgency: "",
        accountTaxPayer: "",
        holderName: "",
        chatPrice: "",
        videoPrice: "",
        userIdDocument: "",
        professionalDocument: "",
        categoryId: "" */

  renderProfessionalForm = () => {
    return (
      <React.Fragment>
        <div>
          <div className="padding text-center relative">
            <button onClick={this.previousStep} className="back-btn">
              Voltar
            </button>
            <h3>Profissional</h3>
          </div>
          {/* <Row form>
            <Col md={6}>
              <FormGroup>
                <Label>Conta</Label>
                <Input
                  value={this.state.professionalPayload.bankAccount}
                  onChange={e =>
                    this.onChangeForm(
                      { bankAccount: e.target.value },
                      "professionalPayload"
                    )
                  }
                />
              </FormGroup>
            </Col>
            <Col md={6}>
              <FormGroup>
                <Label>Agência</Label>
                <Input
                  value={this.state.professionalPayload.bankAgency}
                  onChange={e =>
                    this.onChangeForm(
                      { bankAgency: e.target.value },
                      "professionalPayload"
                    )
                  }
                />
              </FormGroup>
            </Col>
          </Row>
          <FormGroup>
            <Label>Nome do titular</Label>
            <Input
              value={this.state.professionalPayload.holderName}
              onChange={e =>
                this.onChangeForm(
                  { holderName: e.target.value },
                  "professionalPayload"
                )
              }
            />
          </FormGroup>
          <FormGroup>
            <Label>CPF do titular</Label>
            <Input
              value={this.state.professionalPayload.accountTaxPayer}
              onChange={e =>
                this.onChangeForm(
                  { accountTaxPayer: e.target.value },
                  "professionalPayload"
                )
              }
            />
          </FormGroup>
          Preços (por hora)
          <Row form>
            <Col md={6}>
              <FormGroup>
                <Label>Chat</Label>
                <Input
                  value={this.state.professionalPayload.chatPrice}
                  onChange={e =>
                    this.onChangeForm(
                      { chatPrice: e.target.value },
                      "professionalPayload"
                    )
                  }
                />
              </FormGroup>
            </Col>
            <Col md={6}>
              <FormGroup>
                <Label>Videochamada</Label>
                <Input
                  value={this.state.professionalPayload.videoPrice}
                  onChange={e =>
                    this.onChangeForm(
                      { videoPrice: e.target.value },
                      "professionalPayload"
                    )
                  }
                />
              </FormGroup>
            </Col>
          </Row> */}
          <FormGroup>
            <Label for="category-select">Selecione sua especialidade</Label>
            <Input
              type="select"
              name="select"
              id="category-select"
              onChange={e =>
                this.onChangeForm(
                  { categoryId: e.target.value },
                  "professionalPayload"
                )
              }
              value={this.state.professionalPayload.categoryId}
            >
              <option disabled value={""}>
                Sua especialidade
              </option>
              {this.props.categories.map(item => (
                <option key={item._id} value={item._id}>
                  {item.name}
                </option>
              ))}
            </Input>
          </FormGroup>
          {/* <FormGroup>
          <Label>Documento de identidade</Label>
          <Input
            type="file"
            value={this.state.userIdFile}
            onChange={e => this.setState({ userIdFile: e.target.value })}
          />
        </FormGroup>
        <FormGroup>
          <Label>Comprovação Profissional</Label>
          <Input
            type="file"
            value={this.state.professionalFile}
            onChange={e => this.setState({ professionalFile: e.target.value })}
          />
        </FormGroup> */}
        </div>
        <Button
          disabled={!this.state.professionalPayload.categoryId}
          className="btn btn-dark btn-form mb-1 mt-3 d-block mx-auto"
          type="submit"
          value="Submit"
        >
          Cadastrar
        </Button>
      </React.Fragment>
    );
  };

  renderContent = () => {
    switch (this.state.step) {
      case 0:
        return this.renderInitialPage();
      case 1:
        return this.renderAccountForm();
      case 2:
        return this.renderAddressForm();
      case 3:
        return this.renderProfessionalForm();
      default:
        return this.renderInitialPage();
    }
  };

  render() {
    if (this.props.authUser) return <Redirect to={"/profile"} />;
    return (
      <div>
        {/* <Header /> */}
        <div className="container-form">
          <Container>
            {this.state.typeChoosed ? (
              <div className="row justify-content-center">
                <Col md="6" xs="12" className="generic-form">
                  <Form onSubmit={this.nextStep}>
                    {this.props.isLoading === false
                      ? null
                      : this.renderLoading()}
                    <div>
                      {this.props.createAccountError
                        ? this.renderAlert()
                        : null}
                    </div>

                    {this.renderContent()}
                  </Form>
                </Col>
              </div>
            ) : (
              this.renderInitialPage()
            )}
          </Container>
        </div>
        <Footer />
      </div>
    );
  }
}

const mapDispatchToProps = dispatch => {
  return {
    doSignUp: data => dispatch(UserProvider.createAccount(data)),
    doSetCreateAccountError: error =>
      dispatch(action.setCreateAccountError(error))
  };
};

const mapStateToProps = state => {
  return {
    isLoading: state.user.isLoading,
    createAccountError: state.user.createAccountError,
    categories: state.category.list,
    authUser: state.user.userInfo.token
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(SignUpScreen);
